<!----------------------- Компонент з покроковим описом як відновити пароль --------------------->
<template>
    <div class="container">
        <a href="/"><headloginreg /></a>
        <br>
        <div class="special">
            <div class="currentSpan" @click="goLogin"><b-icon icon="chevron-left" style="margin-right:3px;" font-scale="1.25"></b-icon><span>{{ currentLang === 'ru' ? currentSpan.descRU : currentLang === 'uk' ? currentSpan.descUK : currentSpan.descEN  }}</span></div>
            <div class="specialSelect">
                <SelectLangs @changeLang="changeLang($event)" :utilityLang="currentLang" :limited="language" />
            </div>
        </div>
        <hr>
        <PasswordRecoveryRu v-if="currentLang === 'ru'" :key="currentLang" />
        <PasswordRecoveryUk v-if="currentLang === 'uk'" :key="currentLang" />
        <PasswordRecoveryEn v-if="currentLang === 'en'" :key="currentLang" />
    </div>
</template>

<script>
import { store } from "@/store.js"; // Глобальне сховище даних
import SelectLangs from '../LangSelectComponent.vue'; // Компонент випадаючого списку для вибору мови
import headloginreg from "../heads/HeaderLoginAndReg.vue" // Компонент хедеру з логотипом
import PasswordRecoveryRu from "./PasswordRecoveryContent/PasswordRecoveryRu.vue"
import PasswordRecoveryUk from "./PasswordRecoveryContent/PasswordRecoveryUk.vue"
import PasswordRecoveryEn from "./PasswordRecoveryContent/PasswordRecoveryEn.vue"
export default {
  components: {
    headloginreg,
    SelectLangs,
    PasswordRecoveryRu,
    PasswordRecoveryUk,
    PasswordRecoveryEn
  },
  data () {
    return {
      currentLang: "", // Поточний вибір мови
      language: [
        { name: 'uk', text: 'UA', description: 'Українська' },
        { name: 'ru', text: 'RU', description: 'Русский' },
        { name: 'en', text: 'EN', description: 'English' }
      ], // Список доступних мов
      currentSpan: {
        descUK: 'Авторизація',
        descRU: 'Авторизация',
        descEN: 'Authorization'
      } // Опис для кожної мови
    }
  },
  created() {
    // Костиль для політик
    switch(store.lang){
      case "ru":
      case "uk":
      case "en":
        this.currentLang = store.lang;
        break;
      default:
        this.currentLang = 'en';
        break;
    }
  },
  methods: {
    // Функція для зміни мови в додатку: зберігає вибір користувача, оновлює стан у хранилищі та глобальну змінну
    changeLang(l) {
      localStorage.setItem("lang_user", l);
      store.lang = l;
      window.lang = store.langs[store.lang]();
      this.currentLang = l
    },
    goLogin() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.img {
  max-width: 100%;
}

.text {
  color: black;
  font-weight: bold;
  margin-bottom: 2rem;
}

.recImg {
  margin-bottom: 2rem;
}

h2 {
  margin-top: 2rem;
  margin-top: 2rem;
  text-align:center;
  color: black;
}

h5 {
  color: black;
  text-align: center;
  margin-bottom: 2rem;
}

.currentSpan {
  cursor: pointer;
  color:#106090;
  margin-top: 12px;
}

.custom-select {
  cursor: pointer;
}

.special {
  display: flex;
  justify-content: space-between;
  height: 35px;
}

body {
  overflow: scroll;
}
</style>
